Vue.component('category-productlist',{
    template:'#category-productlist-template',

    data:function(){
        return{
            list:[],
            loaderIsActive:true,
            filter_discount:false,
            searchString:'',
        }
    },
    created:function(){

        Vue.http.headers.common['X-CSRF-Token'] = document.querySelector('#csrf-token').getAttribute('value');
        activeInstance = this;
        activeInstance.getProducts();
    },
    events: {
        updateSearchString: function(string) {
            this.searchString=string;
        }
    },
    methods:{
        destroyProduct:function(product){

            var confirm = bootbox.confirm('Biztosan el akarod távolítani a terméket?', function(value){
                if(value===true){
                    activeInstance.$http.post(baseURL+'/admin/product/destroy',{id:product.id}).then(function(response){
                        activeInstance.list.$remove(product);
                    });
                }
            });
        },
        getProducts:function(){
            activeInstance.$http.get(baseURL+'/api/products').then(function(response){
                activeInstance.list=response.data;
                //console.log(response);
                activeInstance.loaderIsActive=false;
            });
        },
        toggle_filter_discount:function(status){
            activeInstance.searchString=!status;
        },
        edit:function(product){
            location.href=baseURL + '/admin/product/edit/'+product.id;
        },
        clearSearchString:function(){
            activeInstance.searchString='';
        },
        createProduct:function(){
            bootbox.prompt({
                title: 'Mi legyen az új termék neve?',
                value: '',
                callback: function(result) {
                    if (result === null) {

                    } else {
                        activeInstance.$http.post(baseURL+'/admin/product/create', {name:result}).then(function(response){
                            console.log(response);
                            location.href = baseURL + '/admin/product/edit/' + response.data.id;
                        }).bind(this);
                    }
                }
            });
        }
    },
    computed:
        {
            ifStatement:function()
            {
                if(activeInstance.filter_discount==true){
                    return "'true' in 'has_discounted_portion'";
                }else{
                    return '';
                }
            }
        }
});